
export default function ArrowLong({
  className,
}: {
  className?: string
}) {
  return (
    <svg width="100%" height="100%" className={className} viewBox="0 0 28 9" fill="#101011" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.298763 4.89255V3.63211H8.90908V4.89255H0.298763ZM3.35588 4.89255V3.63211H11.9662V4.89255H3.35588ZM6.413 4.89255V3.63211H15.0233V4.89255H6.413ZM9.47011 4.89255V3.63211H18.0804V4.89255H9.47011ZM12.5272 4.89255V3.63211H21.1375V4.89255H12.5272ZM15.5843 4.89255V3.63211H24.1947V4.89255H15.5843ZM18.6415 4.89255V3.63211H27.2518V4.89255H18.6415ZM21.9932 8.03548L25.9546 4.27051L21.9932 0.521917H23.8757L27.8371 4.27051L23.8757 8.03548H21.9932Z"/>
    </svg>
  )
}
